// src/lib/managerAudit.js
// STATUS: active | UPDATED: 2026-09-17
// LOG:
//   2026-09-17  New. The manager's end of day inspection.
//
// One row per manager per day. See supabase/migrations/0029 for why the labels
// live in src/content/manager.json rather than in the row.
//
// Today is the user's local today, not UTC. A manager finishing a shift at
// 9pm Mountain is still on the same working day, and a UTC date would roll
// their audit over at 5pm and lose half of it.

import { supabase } from './supabase'

export function localToday(d = new Date()) {
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

export async function getToday(userId) {
  if (!userId) return { data: null, error: null }
  const { data, error } = await supabase
    .from('manager_audit')
    .select('id, on_date, items, note')
    .eq('user_id', userId)
    .eq('on_date', localToday())
    .maybeSingle()
  return { data, error }
}

// Upsert on (user_id, on_date), so ticking a box on a day that has no row yet
// creates it and every tick after that updates the same row.
export async function saveToday(userId, items) {
  if (!userId) return { data: null, error: 'Not signed in.' }
  const clean = Array.from(new Set((items || []).filter((n) => Number.isInteger(n) && n >= 0))).sort((a, b) => a - b)
  const { data, error } = await supabase
    .from('manager_audit')
    .upsert(
      { user_id: userId, on_date: localToday(), items: clean, updated_at: new Date().toISOString() },
      { onConflict: 'user_id,on_date' },
    )
    .select('id, on_date, items, note')
    .single()
  return { data, error }
}

// The last fortnight, for the small streak strip. Ordered oldest first so the
// strip reads left to right like a calendar.
export async function recentDays(userId, days = 14) {
  if (!userId) return { data: [], error: null }
  const since = new Date()
  since.setDate(since.getDate() - (days - 1))
  const { data, error } = await supabase
    .from('manager_audit')
    .select('on_date, items')
    .eq('user_id', userId)
    .gte('on_date', localToday(since))
    .order('on_date')
  return { data: data || [], error }
}
